import { useState, useEffect } from "react";

export const useTheme = () => {
  // Dark mode is now default and light mode is temporarily disabled
  const [theme, setTheme] = useState<"light" | "dark">("dark");

  useEffect(() => {
    // Always set dark mode
    document.documentElement.classList.add("dark");
    localStorage.setItem("theme", "dark");
  }, [theme]);

  const toggleTheme = () => {
    // Light mode is temporarily disabled - always keep dark mode
    // setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
    setTheme("dark");
  };

  return { theme, toggleTheme };
};
